export default function buildIDWithStateScope(id, state) {
    return `${state}_${id}`;
}
